export type StudentAttendee = {
  studentId: string,
  firstName: string,
  lastName: string,
  note?: string,
}

export type Tutorial = {
  id: string,
  startDatetimeIdentifier: string,
  duration: number,
  attendees: StudentAttendee[],
  capacity: number,
  course: string,
  host: string,
  joinLink: string,
  description?: string,
  linkedTutorials?: string[]
}

export enum TutorialScope {
  Following = 'following',
  All = 'all',
}
